/* eslint-disable prettier/prettier */
<template>
  <div class="canvas" :id="flow.name" :ref="flow.name" @scroll="positionLine">
    <json-comp :json="flowJSON" v-show="showJSONComponent"></json-comp>
    <div class="navbarcomponent">
      <div class="list_item">

        <div class="nav_component" id="menu" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="menu">{{ icon.menu }}</v-icon>

          </div>
          <div class="icon-txt">Menu</div>
        </div>
        <div class="nav_component" id="audio" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="audio">{{ icon.audio }}</v-icon>
          </div>
          <div class="icon-txt">Audio</div>
        </div>
        <div class="nav_component" id="sms" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="sms">{{ icon.sms }}</v-icon>
          </div>
          <div class="icon-txt">SMS</div>
        </div>
        <div class="nav_component" id="voicemail" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="voice">{{ icon.voicemail }}</v-icon>
          </div>
          <div class="icon-txt">Voice Mail</div>
        </div>
        <div class="nav_component" id="validation" @click="isNameChanged" draggable="true"
          @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="validation">{{ icon.validation }}</v-icon>
          </div>
          <div class="icon-txt">Validation</div>
        </div>
        <div class="nav_component" id="connection" @click="isNameChanged" draggable="true"
          @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="connection">{{ icon.connection }}</v-icon>
          </div>
          <div class="icon-txt">Connection</div>
        </div>
        <div class="nav_component" id="conference" @click="isNameChanged" draggable="true"
          @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="conference">{{ icon.conference }}</v-icon>
          </div>
          <div class="icon-txt">Conference</div>
        </div>
        <div class="nav_component" id="dial" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="dial">{{ icon.dial }}</v-icon>
          </div>
          <div class="icon-txt">Dial</div>
        </div>
        <div class="nav_component" id="hangup" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
          <div class="nav_items">
            <v-icon class="hangup">{{ icon.hangup }}</v-icon>
          </div>
          <div class="icon-txt">Hangup</div>
        </div>
      </div>
    </div>
    <div class="mainViewFlex" style="overflow: hidden; height: 97%; margin: 0px">
      <div style="
          overflow: hidden;
          /* height: calc(100% - 90px); */
          background-repeat: no-repeat;
          position: relative;
          padding: 0px 5px 0px 5px;
        ">
        <div id="123" class="scrolling-canvas" @scroll="positionLine()"
          v-bind:style="[active ? { 'overflow': 'auto' } : { 'overflow': 'hidden' }]">

          <div id="div1" @drop="drop($event)" @dragover="allowDrop($event)" @click.stop="hideFooter($event)"
            class="zoom">
            <slot name="flow"></slot>
            <vue-draggable-resizable v-for="(item, index) in shapes" :key="item.id" :min-width="150" :min-height="100"
              :w="item.w" :h="item.h" :x="item.x" :y="item.y" :class="{ check: true, highlight: item.showFooter }"
              class-name="flow" class-name-handle="custom-handle" :id="item.id" :ref="item.id"
              :draggable="item.draggable" :parent="true" @dragging="positionLine(index)" @resizing="positionLine(index)"
              @activated="activated(index, item)" @deactivated="item.showCircle = false" :active="item.showFooter"
              :style="{ backgroundColor: item.bgcolor, color: icon.bgcolor }">
              <div draggable="true" class="connect-arrow" @dragstart.stop="drag($event, index)"
                @mouseenter="disableDrag" @mouseleave="enableDrag" id="drag"
                v-show="item.showCircle && item.title != 'HANGUP'"></div>
              <div draggable="true" class="connect-arrow-f" @dragstart.stop="drag($event, index)"
                @mouseenter="disableDrag" @mouseleave="enableDrag" id="drag-f" v-show="item.showCircle &&
                  (item.title == 'MENU' ||
                    item.title == 'DIAL' ||
                    item.title == 'VALIDATION')
                  "></div>
              <div class="content" :id="item.id" @drop="dropArrow(item.id, $event, index, item)"
                @dragover="allowDrop($event,)">
                <div :id="item.id" class="content__header" :style="{ backgroundColor: item.bgcolor }">

                  <div>{{ item.title }}</div>
                  <div class="header-options">
                    <v-icon color="#fff" style="font-size: 15px" @click.stop="showFlowFooter(index)">edit</v-icon>
                    <v-icon color="#fff" style="font-size: 15px" v-if="item.data != 'trigger'"
                      @click.stop="removeFlow(index, item)">close</v-icon>
                  </div>
                </div>

                <div :id="item.id" class="content__description" @mouseover="fun()" @mouseleave="hii()">

                  <div style="font-size: 12px;font-weight: 600">
                    <v-icon class="icon">{{ icon[`${item.data}`] }}</v-icon>{{ item.id }}
                    <!-- <span class="name">{{ item.name }}</span> -->

                  </div>

                  <div class="description">{{ item.description }}</div>
                  {{ }}
                </div>
              </div>
            </vue-draggable-resizable>
            <template>
              <div>
                <!-- <vue-draggable-resizable
      v-for="(item, index) in shapes"
      :key="item.id"
      :min-width="150"
      :min-height="100"
      :w="item.w"
      :h="item.h"
      :x="item.x"
      :y="item.y"
      :class="{ check: true, highlight: item.showFooter }"
      class-name="flow"
      class-name-handle="custom-handle"
      :id="item.id"
      :ref="item.id"
      :draggable="item.draggable"
      :parent="true"
      @dragging="positionLine(index)"
      @resizing="positionLine(index)"
      @activated="activated(index, item)"
      @deactivated="item.showCircle = false"
      :active="item.showFooter"
      :style="{ backgroundColor: item.bgcolor }"  
    >
      <div class="content" :id="item.id" @drop="(item.id, $event, index, item)" @dragover="allowDrop($event)">
        <div 
          :id="item.id" 
          class="content__header" 
          :style="{ backgroundColor: item.bgcolor }"  
        >
          <div>{{ item.title }}</div>
          <div class="header-options">
            <v-icon color="#fff" style="font-size: 15px" @click.stop="showFlowFooter(index)">edit</v-icon>
            <v-icon color="#fff" style="font-size: 15px" v-if="item.data !== 'trigger'" @click.stop="removeFlow(index, item)">close</v-icon>
          </div>
        </div>

        <div :id="item.id" class="content__description" @mouseover="fun()" @mouseleave="hii()">
          <div>
            <v-icon>{{ icon[`${item.data}`] }}</v-icon>
            <span class="name">{{ item.name }}</span>
          </div>
          <div style="font-size: 10px">{{ item.id }}</div>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </vue-draggable-resizable> -->
              </div>
            </template>

          </div>
          <!-- <div class="zoom_button_class">
          <v-btn fab samll fixed color="#2194f3" class="zoom-out-bts" @click="zoomOut()">
            <v-icon color="#fff" light>mdi-minus</v-icon>
          </v-btn>
          <v-btn fab samll fixed color="#2194f3" class="zoom-in-bts" @click="zoomIn()">
            <v-icon color="#fff" light>add</v-icon>
          </v-btn>
        </div> -->
        </div>



      </div>
      <div class="upl_btn">

        <div class="button_main_cls">
          <button class="bts_clss" @click="cancelFlow()" style="background: #2194f3; color: white">
            Cancel
          </button>
          <button class="bts_clss" @click="uploadJSON()" style="background: #2194f3; color: white">
            Save
          </button>
        </div>
      </div>
    </div>
    <v-snackbar v-model="Snackbar.show" :bottom="true" :right="true" :timeout="Snackbar.timeout">
      {{ Snackbar.text }}
      <v-btn color="pink" flat @click="Snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="alert" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title>
            <span class="headline">Alert! </span>
          </v-card-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text text-bold>{{ alertmessage }}</v-card-text>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closealert()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" right :timeout="time" top color="#fff">
      <span style="color: #000">Zoom: {{ zoomalert }}</span>
    </v-snackbar>

    <!-- <v-btn fab samll fixed color="#2194f3" class="zoom-out" @click="zoomOut()">
 <v-icon color="#fff" light>mdi-minus</v-icon>
 </v-btn>
 <v-btn fab samll fixed color="#2194f3" class="zoom-in" @click="zoomIn()">
 <v-icon color="#fff" light>add</v-icon>
 </v-btn> -->

    <div v-for="(footer, index) in shapes" :key="`${index}_${footer.id}`" class="foot" v-show="footer.showFooter">
      <div class="tabflex">

        <div @click="selecttab('general')" :class="{ tabitem: props_tab_index === 'general', tabitempadding: true }">
          General
        </div>
        <div v-if="footer.data != 'hangup' && footer.data != 'voicemail'" @click="selecttab('settings')"
          :class="{ tabitem: props_tab_index === 'settings', tabitempadding: true }">Settings</div>
        <div v-if="footer.data === 'menu'" @click="selecttab('control')"
          :class="{ tabitem: props_tab_index === 'control', tabitempadding: true }">Control</div>
      </div>

      <div v-if="props_tab_index == 'general'" class="fix-height">
        <div>
          <div class="input">
            <label for="title">Title</label>
            <input v-model="footer.name" type="text" name="title" id="title" placeholder="Enter title text" />
          </div>
          <div class="input">
            <label for="desc">Description</label>
            <textarea placeholder="Enter description text" v-model="footer.description" name="desc" id="desc" cols="44"
              rows="5"></textarea>
          </div>
        </div>
      </div>
      <div v-if="props_tab_index == 'control'" class="fix-height">
        <div class="menu-settings" v-show="footer.data == 'menu' && footer.showFooter">
          <div class="table-view-parallel">
            <table class="table">
              <thead>
                <tr>
                  <th>Next</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(key, i) in menuItems" :key="i">
                  <td>
                    <div class="input">
                      <input width="50%" display="inline" v-model="menuValues[i]"
                        @input="menuControl(footer.id, i, menuValues[i])" type="text" id="key" />
                    </div>
                  </td>
                  <td>
                    <v-select :items="menuItems" label="Components" v-model="menuChoices[i]"
                      @input="checkValueExist(i, menuChoices[i], footer.id)" persistent-hint></v-select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="props_tab_index == 'settings' && footer.data !== 'hangup'" class="fix-height">
        <div v-if="footer.data == 'dial'">
          <div class="input_">
            <v-select :items="dialTypes" label="Select Dial Type" return-object v-model="footer.settings.dialType"
              persistent-hint></v-select>
          </div>
          <div class="input_" v-if="footer.settings.dialType === 'Queue'">
            <v-select :items="queueTypes" label="Select Queue" return-object v-model="footer.settings.queue"
              persistent-hint></v-select>

          </div>
          <div class="input_" v-if="footer.settings.dialType === 'Number'">

            <v-select :items="dialoptions" v-model="footer.settings.DID" placeholder="Select Number"></v-select>
          </div>
          <div class="input" v-if="footer.settings.DID === 'Others' && dialtype === 'Number'">
            <label for="caller">Number</label>
            <input v-model="footer.settings.DIDNumber" type="text" name="caller" id="caller"
              placeholder="Enter Phone Number" />
          </div>

          <div class="input_" v-if="footer.settings.dialType === 'Queue' || footer.settings.DID === 'Agent'">
            <v-autocomplete v-model="footer.settings.users" :items="userData" label="Choose Agent" persistent-hint
              item-text="user_name" key="user_name" return-object small multiple single-line :allow-overflow="false">
            </v-autocomplete>
          </div>
        </div>
        <div v-else-if="footer.data == 'hangup'"></div>
        <div class="trigger-settings" v-else-if="footer.data == 'trigger'">
          <div class="input">
            <label for="desc">DID</label>
            <input v-model="footer.settings.did" type="text" name="desc" id="desc" placeholder="Enter DID" />
          </div>
          <div class="input">
            <v-checkbox v-model="footer.settings.check_balance" label="Check Balance"></v-checkbox>
          </div>
          <div class="input" v-if="footer.settings.check_balance">
            <label for="balance">Balance</label>
            <input v-model="footer.settings.balance" type="number" name="balance" id="balance"
              placeholder="Enter balance" />
          </div>
        </div>

        <div class="audio-settings" v-else-if="footer.data == 'audio'">
          <div class="input-view-parallel">

            <input type="radio" name="audioChooser" v-on:change="audioOptions" v-model="audioOption"
              value="upload_file" />
            <label style="font-size: 12px; padding: 5px">Upload File</label>
            <input type="radio" name="audioChooser" v-on:change="audioOptions" v-model="audioOption"
              value="choose_file" />
            <label style="font-size: 12px; padding: 5px">Select File</label>
            <div class="input" v-if="audioUpload">

              <label for="file">Audio File</label>
              <input accept=".mp3,audio/*" @change="addFile" type="file" name="audio-audio_file" :id="footer.id"
                ref="fileInput" />
              <textarea v-model="audio_discription" name="audio_txt" id="audio_txt" cols="44" rows="5"
                placeholder="Type Your Discription" style="margin-top: 5px;"></textarea>
              <button @click="saveAudio()" class="bts_clss" style="background: #2194f3; color: white">
                Save File
              </button>
            </div>
            <div class="input_" v-if="audioChoose">
              <label for="file">Audio File</label>
              <v-select :items="audioFiles" v-model="audioFile" @input="audioFilesUpload(audioFile, footer.id)"
                placeholder="Select Audio File"></v-select>
            </div>
            <div class="input">
              <v-checkbox v-model="footer.settings.expect" :color="'primary'"
                @change="checkDTMF(footer.settings.expect, footer.id)" label="Expect DTMF"></v-checkbox>
            </div>
          </div>
        </div>
        <div class="vmail-settings" v-else-if="footer.data == 'voicemail'">
          <div class="input">
            <label for="vmail_num">Number</label>
            <input v-model="footer.settings.vmail_num" type="text" name="vmail_num" id="vmail_num"
              placeholder="Enter Phone Number" />
          </div>
        </div>
        <div class="sms-settings" v-else-if="footer.data == 'sms'">
          <!-- <div class="input_">
            <label for="sms_opt">SMS</label>
            <v-select :items="smsTypes" v-model="footer.settings.sms_opt"
                placeholder="Select Sms Option"></v-select>
           
          </div> -->
          <!-- <div class="input" v-if="footer.settings.sms_opt === 'Others'">
            <label for="sms_num">Number</label>
            <input v-model="footer.settings.sms_num" type="text" name="sms_num" id="sms_num"
              placeholder="Enter Phone Number" />
          </div> -->

          <div class="input">
            <label for="sms_api">SMS API</label>
            <input v-model="footer.settings.sms_api" type="text" name="sms_api" id="sms_api"
              placeholder="Enter API URL" />
          </div>
          <div class="input">
            <label for="sms_txt">Message</label>
            <textarea v-model="footer.settings.sms_txt" name="sms_txt" id="sms_txt" cols="44" rows="5"
              placeholder="Type Your Message"></textarea>
          </div>
        </div>
        <div class="conference-settings" v-else-if="footer.data == 'conference'">
          <div class="input">
            <label for="conf_num">Bridge Number</label>
            <input v-model="footer.settings.conf_num" type="text" name="conf_num" id="conf_num"
              placeholder="Enter Phone Number" />
          </div>
        </div>
        <div class="validation-settings" v-else-if="footer.data == 'validation'">
          <div class="input">
            <label for="time_cond">Time Condition</label>
            <input v-model="footer.settings.time_from" type="time" name="time_from" id="time_from" placeholder="From" />
            <input v-model="footer.settings.time_to" type="time" name="time_to" id="time_to" placeholder="To" />
          </div>
          <div class="input_table">
            <div class="validationheader validation-settings">
              <div>
                <label for="validate_param">Validate</label>
              </div>
              <div>
                <Button class="add-button" @click="addSection(footer.id)">Add</Button>
              </div>
            </div>

            <div v-for="(key, i) in no_of_validate" :key="i" class="validation_row">
              <div class="validationheader validation-settings">
                <div>
                  <label for="validate_param">Validate -{{ i + 1 }}</label>
                </div>
                <div>
                  <Button class="add-button" v-if="i !== 0" @click="removeSection(key)">Delete</Button>
                </div>
              </div>

              <div>
                <v-select v-model="validateParam[i]" :items="variables" style="
                      /* width: 90px;
                      padding: 5px; */
                      overflow: hidden;
                      text-overflow: clip;
                    " name="validate_param" @change="
                      add_validate('param', footer.id, i, validateParam[i])
                      " id="validate_param" placeholder="Param" />
              </div>
              <div>
                <v-select v-model="validateOperation[i]" :items="operations" style="
                      /* width: 90px;
                      padding: 5px; */
                      overflow: hidden;
                      text-overflow: clip;
                    " name="operation" @change="
                      add_validate('opera', footer.id, i, validateOperation[i])
                      " id="operation" placeholder="Operation" />
              </div>
              <div>

                <input v-model="validateValue[i]" type="text" name="validate_value" @change="
                  add_validate('value', footer.id, i, validateValue[i])
                  " id="validate_value" placeholder="Value" class="custom-input" />
              </div>
            </div>

          </div>
        </div>
        <div class="connection-settings" v-else-if="footer.data == 'connection'">
          <div class="input_">
            <label for="conn_method">Connection</label>
            <v-select :items="connMethods" v-model="footer.settings.conn_method"
              placeholder="Select Connection Method"></v-select>

          </div>
          <div class="input_">
            <label for="conn_type">Type</label>
            <v-select :items="connTypes" v-model="footer.settings.conn_type"
              placeholder="Select Connection Type"></v-select>

          </div>
          <div class="input">
            <label for="conn_api">API</label>
            <input v-model="footer.settings.conn_api" type="text" name="conn_api" id="conn_api"
              placeholder="Enter API URL" />
          </div>
          <!-- <div class="input">
            <label for="conn_res">Response</label>
            <textarea @change="add_response(footer.id, footer.settings.conn_res)" v-model="footer.settings.conn_res"
              name="conn_res" id="conn_res" cols="44" rows="3" placeholder="Enter Response"></textarea>
          </div> -->
          <div class="input_table">
            <!-- <label for="api_param">Parameters</label> -->
            <div class="validationheader validation-settings">
              <div>
                <label for="validate_param">Parameters</label>
              </div>
              <div>
                <Button class="add-button" @click="addParametersSection(footer.id)">Add</Button>
              </div>
            </div>

            <div v-for="(key, i) in footer.settings.api_param" :key="i" class="validation_row">
              <div class="validationheader validation-settings">
                <div>
                  <label for="validate_param">Parameters -{{ i + 1 }}</label>
                </div>
                <div>
                  <Button class="add-button" v-if="i !== 0"
                    @click="removeParametersSection(i, footer.id)">Delete</Button>
                </div>
              </div>

              <div>
                <input v-model="paramkeys[i]" type="text" name="api_param"
                  @change="add_params('key', footer.id, i, paramkeys[i])" id="api_param" placeholder="Key"
                  class="custom-input" />
              </div>
              <div>
                <v-select v-if="valueDrop[i]" v-model="paramvalues[i]" :items="variables" style="
                      
                      overflow: hidden;
                      text-overflow: clip;
                    " name="api_value" @change="add_params('value', footer.id, i, paramvalues[i])" id="api_value"
                  placeholder="Value" />
                <input v-if="valueText[i]" v-model="paramvalues[i]" type="text" name="api_value"
                  @change="add_params('value', footer.id, i, paramvalues[i])" id="api_value" placeholder="Value" />
              </div>
            </div>

          </div>
        </div>
        <div class="menu-settings" v-else-if="footer.data == 'menu'">
          <div class="input-view-parallel">
            <input type="radio" name="menuChooser" v-on:change="menuOptions" v-model="radioOption"
              value="upload_file" />
            <label style="font-size: 12px; padding: 5px">Upload File</label>
            <input type="radio" name="menuChooser" v-on:change="menuOptions" v-model="radioOption"
              value="choose_file" />
            <label style="font-size: 12px; padding: 5px">Select File</label>
            <div class="check" v-if="menuUpload">
              <div class="input_">
                <label for="file">Select Audio Type</label>
                <v-select :items="audiotypearray" v-model="audiotype" placeholder="Audio Type"
                  @input="selectaudiotype('invalid', menuInvalid, footer.id)"></v-select>
              </div>

              <div v-if="audiotype === 'Menu Audio'" class="input">
                <label for="file">Menu Audio File</label>
                <input accept=".mp3,audio/*" @change="addFile" type="file" name="menu-audio_file" :id="footer.id" />
                <textarea v-model="audio_discription" name="audio_txt" id="audio_txt" cols="44" rows="5"
                  placeholder="Type Your Discription" style="margin-top: 5px;"></textarea>
                <button @click="saveAudio()" class="bts_clss" style="background: #2194f3; color: white">
                  Save File
                </button>
              </div>
              <div v-if="audiotype === 'Invalid Audio'" class="input">
                <label for="file">Invalid Audio File</label>
                <input accept=".mp3,audio/*" @change="addFile" type="file" name="menu-invalid_file" :id="footer.id" />
                <textarea v-model="audio_discription" name="audio_txt" id="audio_txt" cols="44" rows="5"
                  placeholder="Type Your Discription" style="margin-top: 5px;"></textarea>
                <button @click="saveAudio()" class="bts_clss" style="background: #2194f3; color: white">
                  Save File
                </button>
              </div>
            </div>
            <div class="check" v-if="menuChoose">
              <div class="input_">
                <label for="file">Menu Audio File</label>
                <v-select :items="audioFiles" v-model="menuValid" @input="menuFiles('valid', menuValid, footer.id)"
                  placeholder="Select Audio File"></v-select>
              </div>
              <div class="input_">
                <label for="file">Invalid Audio File</label>
                <v-select :items="audioFiles" v-model="menuInvalid" placeholder="Select Audio File"
                  @input="menuFiles('invalid', menuInvalid, footer.id)"></v-select>
              </div>
            </div>
            <!-- <div class="input">
 <label for="file">Timeout Audio File</label>
 <input
 accept=".mp3,audio/*"
 @change="addFile"
 type="file"
 name="menu-timeout_file"
 :id="footer.id"
 />
 </div> -->
            <div class="input">
              <label for="file">Timeout (seconds)</label>
              <input v-model.number="footer.settings.timeout" type="number" name="repeat" id="repeat" />
            </div>
            <div class="input">
              <label for="file">Repeat (times)</label>
              <input v-model.number="footer.settings.repeat" type="number" name="repeat" id="repeat" />
            </div>
            <!-- <div class="input">
 <v-checkbox
 v-model="footer.settings.skip"
 label="Skip on DTMF"
 ></v-checkbox>
 </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LeaderLine from "leader-line-vue";
import VueDraggableResizable from "vue-draggable-resizable";
import { mapGetters } from "vuex";
import { isNumber } from "util";
import JsonComp from "./json";
import api from "@/utils/axios-util";
import { validation_function } from "../CallFlowValidation";
export default {
  props: ["flow", "lines", "showJSON"],
  components: {
    JsonComp: JsonComp,
    "vue-draggable-resizable": VueDraggableResizable,
  },
  data() {
    return {
      dialoptions: ['Dial Status', "Agent", 'Others'],
      audiofileFormdata: "",
      audio_discription: "",
      audioname: "",
      audioid: "",
      active: true,
      visibleId: false,
      watchers: false,
      time: 4000,
      presetLine: [
        { type: "l", site: 100 },
        { type: "v", site: 200 },
      ],
      width: 60,
      height: 60,
      x: 0,
      y: 0,
      tenant_code: "",
      props_tab_index: "general",
      bgcolor: {
        dial: "#32cd32",
        sms: "#1da1f2",
        audio: "#ffa500",
        menu: "#4a4a4a",
        voicemail: "#8a2be2",
        validation: "#28a745",
        connection: "#20c997",
        conference: "#008080",
        hangup: "#ff4b4b"
      },
      icon: {
        dial: "fa-solid fa-phone",
        audio: "fa-volume-up",
        trigger: "bolt",
        menu: "fa-solid fa-bars",
        sms: "fas fa-sms",
        voicemail: "fa-solid fa-microphone",
        validation: "fas fa-check-circle",
        connection: "fa fa-random",
        conference: "fa fa-users",
        hangup: "fas fa-phone-slash",
      },

      show: false,
      radioOption: "upload_file",
      audioOption: "upload_file",
      audioChoose: false,
      audioUpload: true,
      menuUpload: true,
      menuChoose: false,
      menuValid: "",
      audioFile: "",
      menuInvalid: "",
      audiotype: "",
      variables: ["DID Number", 'Dial Status', "Caller", "Agent", 'Others'],
      valueText: [false],
      valueDrop: [true],
      options: {
        dial: {},
        hangup: {},
        audio: {
          audio: "",
          timeout: "",
          repeat: "",
        },
        voicemail: {
          vmail_num: "",
        },
        sms: {
          sms_opt: "",
          sms_num: "",
          sms_txt: "",
          sms_api: "",
        },
        validation: {
          rules: [
            {
              parameter: "",
              operation: "",
              value: "",
            },
          ],
          time_from: "",
          time_to: "",
        },
        connection: {
          conn_method: "",
          conn_type: "",
          conn_api: "",
          api_param: [""],
          api_value: [],
        },
        conference: {
          conf_num: "",
        },
        trigger: {
          did: "",
          check_balance: false,
        },
        menu: {
          choices: [],
          keys: [],
          files: {
            menu_valid: "",
            menu_invalid: "",
          },
        },
      },
      no_of_params: [1],
      paramkeys: [],
      paramvalues: [],
      menuChoices: [],
      menuItems: [],
      menuValues: [],
      connections: [
        { name: "Option 1", value: "option1" },
        { name: "Option 2", value: "option2" },
        { name: "Option 3", value: "option3" },
      ],
      type: [
        { name: "Inbound", value: "inbound" },
        { name: "Outbound", value: "outbound" },
      ],
      elements: ["trigger"],
      dialTypes: ["Queue", "Number"],
      queueTypes: ["Queue1", "Queue2"],
      smsTypes: ['Dial Status', "Caller", "Agent", "Others"],
      connMethods: ["GET", "POST", "PUT", "DELETE"],
      connTypes: ["TEXT", "JSON", "XML", "Form-urlencoded"],
      audioFiles: [],
      audiotypearray: ["Menu Audio", "Invalid Audio"],
      shapeCount: 1,
      operations: [
        "LIKE",
        "LIKE %...%",
        "NOT LIKE",
        "IN",
        "NOT IN",
        "IS NULL",
        "IS NOT NULL",
        "BETWEEN",
        "NOT BETWEEN",
        "=",
        ">",
        "<",
        ">=",
        "<=",
        "!=",
      ],
      validateParam: [],
      validateValue: [],
      validateOperation: [],
      no_of_validate: [1],
      dataValue: [],
      flow_id_name: "",
      shapes: [
        {
          id: `CTI-${this.flow.name}-trigger0`,
          data: "trigger",
          name: "trigger",
          x: 45,
          y: 18,
          w: 150,
          h: 100,
          title: "TRIGGER",
          description: "Description",
          draggable: true,
          showFooter: false,
          showCircle: false,
          settings: {
            did: "",
            check_balance: false,
          },
          next: {
            success: "",
            failure: "",
          },
        },
      ],
      line: [],
      start: "",
      end: "",
      showCircle: false,
      showFooter: false,
      zoom: "",
      connectors: [],
      Snackbar: {
        show: false,
        timeout: 1000,
        text: "",
      },
      flowJSON: {},
      showJSONComponent: false,
      alert: false,
      alertmessage: "",
      lineColor: "#000",
      lineType: "success",
      currentFlow: 0,
      offsetX: 0,
      offsetY: 0,
      selectedFlow: 0,
      highlightedFlowIndex: -1,
      zoomProperties: {
        defaults: {
          chrome: {
            browser: "chrome",
            zoom: 100,
            default: 100,
            step: 10,
            suffix: "%",
            prefix: "",
            property: "zoom",
            min: 30,
            max: 200,
            unit: 1,
          },
          firefox: {
            browser: "firefox",
            zoom: 1,
            default: 1,
            step: 0.1,
            suffix: ")",
            prefix: "scale(",
            property: "-moz-transform",
            min: 0.5,
            max: 2,
            unit: 100,
          },
        },
        current: {},
      },
      snackbar: false,
      activatedIndex: null,
      userData: [],
    };
  },

  mounted() {
    window.addEventListener('scroll', this.updateLeaderLinePosition);
    window.addEventListener('resize', this.updateLeaderLinePosition);
    const scope = this;
    this.audioOptions()
    this.menuOptions()
    this.flow.name = localStorage.getItem("flowName");
    scope.tenant_code = localStorage.getItem("TenantCode");
    scope.generateJSON();
    scope.findAudio();
    console.log("Shapes");
    scope.isNameChanged();
    window.addEventListener("keyup", (e) => {
      if (e.key == "Delete") {
        if (scope.highlightedFlowIndex >= 0) {
          scope.removeLine(scope.highlightedFlowIndex);
        }
      } else if (e.key === "Escape") {
        if (scope.highlightedFlowIndex >= 0) {
          scope.unHighlightLine(scope.highlightedFlowIndex);
        }
      }
    });
    var isFirefox = typeof InstallTrigger !== "undefined";
    var isChrome = navigator.userAgent.includes("Chrome");
    let browser = "";
    if (isChrome) {
      browser = "chrome";
    } else if (isFirefox) {
      browser = "firefox";
    }
    if (browser !== "") {
      scope.zoomProperties.current = scope.zoomProperties.defaults[browser];
    }

    scope.$store
      .dispatch("queueManagement", { name: "", take: 100, skip: 0 })
      .then((response) => {
        if (response.data.statusCode === 200) {
          const qType = response.data.data;
          var qTypes = [];
          qType.forEach((q) => {
            qTypes.push(q.name);
          });
          scope.queueTypes = qTypes;
        }
      });
    scope.$store
      .dispatch("userManagement", { skip: 0, take: 100 })
      .then((response) => {
        if (response.data.statusCode === 200) {
          scope.userData = response.data.data.map((user) => {
            return {
              phone_number: user.user_phone_number,
              user_name: user.user_email,
            };
          });
        }
      });
  },
  methods: {
    updateLeaderLinePosition() {
      // Logic to update/recalculate the leader line positions
      this.shapes.forEach((item, index) => {
        this.positionLine(index); // Adjust this to your actual line reposition logic
      });
    },
    addSection() {
      var scope = this;
      var len = scope.no_of_validate.length;
      scope.no_of_validate.push(scope.no_of_validate[len - 1] + 1);
    },
    addParametersSection(val) {
      console.log(val, "footer.settings.api_paramfooter.settings.api_param")
      var scope = this;
      var len = scope.no_of_params.length;
      scope.no_of_params.push(scope.no_of_params[len - 1] + 1);
      scope.shapes.map(function (shape) {

        if (shape.id == val) {
          shape.settings.api_param.push("")
        }
        return shape;
      });
    },
    removeParametersSection(id, footer_id) {
      console.log(id)
      var scope = this;
      let arr = []
      scope.no_of_params.map(function (shape) {
        if (shape != id) {
          arr.push(shape);
        }
        return shape;
      });
      scope.no_of_params = arr
      scope.shapes.map(function (shape) {

        if (shape.id == footer_id) {
          let arr = []
          for (let i = 0; i < shape.settings.api_param.length; i++) {
            const element = shape.settings.api_param[i];
            if (i !== id) {
              arr.push(element)
            }

          }
          shape.settings.api_param = arr
          // shape.settings.api_param.push("")
        }
        return shape;
      });
    },
    removeSection(id) {
      var scope = this;
      let arr = []
      scope.no_of_validate.map(function (shape) {
        if (shape != id) {
          arr.push(shape);
        }
        return shape;
      });
      scope.no_of_validate = arr
    },
    selecttab(data) {
      this.props_tab_index = data
    },
    hii() {
      this.visibleId = false;

    },
    fun() {

      this.visibleId = true;

    },
    selectaudiotype() {
      this.audiofileFormdata = ""
      this.audio_discription = ""
      this.audioname = ""
      this.audioid = ""
    },
    cancelFlow() {
      var scope = this;
      scope.$router.push({ name: "CallFlow" });
    },
    closealert() {
      this.alert = false;
    },
    findAudio() {
      var scope = this;
      let data = "Active";
      console.log("Enter");
      scope.$store.dispatch("FindAudio", data).then((response) => {
        var len = this.tenant_code.length;
        var datas = response.data.records;
        if (datas !== "" && datas !== undefined && datas !== null) {
          datas.forEach((element) => {
            scope.audioFiles.push(element["file_name"].substring(len + 1));
          });
        }
      });
    },
    add_response(id, value) {
      let var_len = this.variables.length;
      let temp = [];
      for (let j = 0; j < var_len; j++) {
        if (this.variables[j].indexOf(id) > -1) {
          temp.push(this.variables[j]);
        }
      }
      this.variables = this.variables.filter((name) => {
        return !temp.includes(name);
      });
      let values = value.split(",");
      for (let i = 0; i < values.length; i++) {
        let v = id + "." + values[i];
        this.variables.push(v);
      }
    },
    add_validate(typ, id, index, val) {
      var scope = this;
      if (typ == "param") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            if (shape.settings.rules[index] === undefined) {
              shape.settings.rules[index] = {
                parameter: "",
                operation: "",
                value: "",
              };
            }
            shape.settings.rules[index].parameter = val;
            // shape.settings.rules[index].parameter[index + 1] = "";

          }
          return shape;
        });


      }
      if (typ == "opera") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.rules[index].operation = val;
          }
          return shape;
        });
      }
      if (typ == "value") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.rules[index].value = val;
          }
          return shape;
        });
      }
      console.log("OOO", typ, id, index, val);
    },
    add_params(typ, id, index, val) {
      var scope = this;
      if (val === "Others") {
        scope.valueDrop[index] = false;
        scope.valueText[index] = true;
      }
      if (val !== "" && val !== undefined && typ == "key") {

        scope.valueText.push(false);
        scope.valueDrop.push(true);
      }
      if (typ == "key") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {

            shape.settings.api_param[index] = val;


          }
          return shape;
        });
      }
      if (typ == "value") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.api_value[index] = val;
          }
          return shape;
        });
      }
    },
    isNameChanged() {
      console.log("mmmmmmmmmmmmmmmmmmm");
      //this function is used for to check flow or file name is changed or not
      if (this.flow.name.substr(0, this.flow.name.length - 1) == "Untitled") {
        this.show = !this.show;
      }
    },
    menuControl(id, key, data) {
      console.log("Id", id, key, data, this.menuValues);
      console.log("Shapes", this.shapes);
      let arr = []
      for (let i = 0; i < this.menuValues.length; i++) {
        const element = this.menuValues[i];
        console.log(element, "eeeeeeeee", key === i)
        if (key === i) {

          if (element === "*" || element === "#" || (Number(element) >= 0 && Number(element) <= 9)) {
            arr.push(element)
          } else {
            arr.push("")
          }


        } else {
          arr.push(element)
        }


      }
      console.log(arr)
      this.menuValues = arr
      //this function is used to prevent duplicate value in menu key in sitting tab
      var scope = this;
      // var static_keys = [];
      if (data > 0) {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.keys[key] = data;
            // shape.settings.keys.forEach((key) => {
            // if (!static_keys.includes(key)) {
            //   static_keys.push(key);
            //   const index = static_keys.indexOf(key);
            //   shape.settings.choices[index].key = key;
            // } else {
            //   for (let j = 0; j < 10; j++) {
            //     if (!static_keys.includes(j)) {
            //       static_keys.push(j);
            //       const index = static_keys.indexOf(j);
            //       shape.settings.choices[index].key = j;
            //       break;
            //     }
            // }
            // }
            // });
            // shape.settings.keys = static_keys;
          }
          return shape;
        });
      }

    },
    checkValueExist(key, choices, id) {
      // const static_shapes = [];
      console.log("1");
      this.shapes.map(function (shape) {
        if (shape.id == id) {
          shape.settings.choices[key] = choices;
          // alert(JSON.stringify(shape.settings.choices));
          // const static_choices = shape.settings.choices;
          // shape.settings.choices = [];
          // const value_array = shape.next.success.split(",");
          // static_choices.forEach(choice => {
          //   alert(JSON.stringify(value_array) + ":" + JSON.stringify(choice));
          //   if (!value_array.includes(choice.value)) {
          //     choice.value = "";
          //   }
          //   static_choices.push(choice);
          // });
        }
        // static_shapes.push(shape);
        return shape;
      });
      // this.dispatch("updateJSON", this.shape);
    },
    // checkValueExist(selectData, id, index) {
    // eslint-disable-next-line prettier/prettier
    //this function is used to prevent duplicate value in dropdown menu item in sitting tab
    // var scope = this;
    // const static_shapes = [];
    // const static_shapes = scope.shapes.map(function (shape) {
    //   if (shape.id === id && shape.id.split("-")[2].substring(0, 4) === "menu") {
    //     for (let i = 0; i < shape.settings.choices.length; i++) {
    //       if (i != index && shape.settings.choices[i].value == selectData) {
    //         shape.settings.choices[i].value = "";
    //       }
    //     }
    //   }
    //   return shape;
    // });
    //   scope.shapes.forEach(shape => {
    //     if (
    //       shape.id === id &&
    //       shape.id.split("-")[2].substring(0, 4) === "menu"
    //     ) {
    //       for (let i = 0; i < shape.settings.choices.length; i++) {
    //         if (i != index && shape.settings.choices[i].value == selectData) {
    //           shape.settings.choices[i].value = "";
    //         }
    //       }
    //     }
    //     static_shapes.push(shape);
    //   });
    //   // alert(JSON.stringify(static_shapes));
    // },
    showFlowFooter(index) {



      let scope = this
      this.shapes.forEach((shape, i) => {

        shape.showFooter = false
        if (shape.data === 'audio') {
          this.audioFile = shape.settings.audio.split(`${this.tenant_code}_`)[1]
        }
        if (shape.data === "menu" && i === index) {

          scope.menuValues = shape.settings.keys;
          scope.menuChoices = shape.settings.choices; console.log("kokoko", scope.menuValues, shape.settings.choices)


          var menu = shape.next.success.split(",");
          scope.menuItems = menu;

        }

      });

      this.shapes[index].showFooter = !this.shapes[index].showFooter;
      this.props_tab_index = 'general'
    },
    positionLine(selectedFlow) {
      //this function is used for when we move element and that flow line should also align properly with new element position
      if (isNumber(selectedFlow)) {
        // this.scrollPage(selectedFlow);
      }
      if (this.line) {
        this.line.forEach((line) => {
          console.log("ytttttttttttttttt", line, 2222222222)
          line.position();
        });
      }
    },
    scrollPage(index) {
      console.log("3");
      //this function is used for when we scroll page the element should not to move
      const flowId = this.shapes[index].id,
        flow = this.$refs[`${flowId}`],
        // div = this.$refs[`${this.flow}`],
        flowBottom = flow[0].$el.getBoundingClientRect().bottom,
        flowRight = flow[0].$el.getBoundingClientRect().right,
        screenBottom = window.innerHeight,
        screenRight = window.innerWidth;
      if (screenBottom - flowBottom < 200) {
        scrollBy(0, 50);
        this.shapes[index].showFooter = false;
      } else if (screenBottom - flowBottom > 400) {
        scrollBy(0, -50);
      }
      if (screenRight - flowRight < 200) {
        scrollBy(50, 0);
      } else if (screenRight - flowRight > 500) {
        scrollBy(-50, 0);
      }
    },
    showSnackBar(message) {
      // this function is used to show alert msg
      var scope = this;
      scope.Snackbar.show = true;
      scope.Snackbar.text = message;
      setTimeout(() => { }, scope.Snackbar.timeout);
    },
    audioOptions() {
      if (this.audioOption == "choose_file") {
        this.findAudio();
        this.audioUpload = false;
        this.audioChoose = true;
      }
      if (this.audioOption == "upload_file") {
        this.audioChoose = false;
        this.audioUpload = true;
      }
    },
    menuOptions() {
      if (this.radioOption == "choose_file") {
        this.audiotype = ""
        this.findAudio();
        this.menuUpload = false;
        this.menuChoose = true;
      }
      if (this.radioOption == "upload_file") {
        this.menuChoose = false;
        this.menuUpload = true;
      }
    },
    saveAudio() {
      this.audiofileFormdata.append("description", this.audio_discription);
      api.defaults.headers["Content-Type"] = "multipart/form-data";
      api
        .post("/audio", this.audiofileFormdata)
        .then((response) => {

          api.defaults.headers["Content-Type"] = "application/json";
          const file_name = response.data.insert.file_name;
          this.shapes.map((shape) => {

            if (shape.id == this.audioid) {
              if (this.audioname.split("-")[0] == "menu") {
                if (this.audioname == "menu-audio_file") {
                  shape.settings.files.menu_valid = file_name;
                }
                if (this.audioname == "menu-invalid_file") {
                  shape.settings.files.menu_invalid = file_name;
                }
                console.log("file", file_name);
              }
              if (this.audioname.split("-")[0] == "audio") {
                shape.settings.audio = file_name;
              }
            }
          });
          console.log("name", this.audioname);
          var leng = this.tenant_code.length;
          if (this.audioname.split("-")[0] == "audio") {
            this.audioFile = file_name.substring(leng + 1);
          }
          if (this.audioname == "menu-audio_file") {
            this.menuValid = file_name.substring(leng + 1);
          }
          if (this.audioname == "menu-invalid_file") {
            this.menuInvalid = file_name.substring(leng + 1);
          }
          this.audiofileFormdata = ""
          this.audio_discription = ""
          this.audioname = ""
          this.audioid = ""
          this.audioOption = "choose_file"
          this.radioOption = "choose_file"
          this.audioOptions()
          this.menuOptions()
          this.findAudio();

        })
        .catch((error) => {
          console.log(error)
          this.audiofileFormdata = ""
          this.$refs.fileInput.value = null;
          api.defaults.headers["Content-Type"] = "application/json";
          this.showSnackBar(error);

        });

    },
    addFile(event) {
      console.log("4", this.audio_discription);
      // this function is used to upload audio files in settings
      // var scope = this;
      let selectedFile = event.target.files[0];
      if (selectedFile.size <= 5000000) {
        let attribute = event.target.attributes;
        this.audioname = attribute.name.nodeValue;
        this.audioid = attribute.id.nodeValue;
        let formData = new FormData();
        formData.append("file_name", selectedFile);
        formData.append("status", "Active");
        this.audiofileFormdata = formData
      } else {
        this.showSnackBar("File Size Must be Below 5MB");
      }
    },
    checkDTMF(bool, id) {
      let dtmf = id + ".dtmf";
      if (bool == true) {
        this.variables.push(dtmf);
      } else if (bool == false) {
        let index = this.variables.indexOf(dtmf);
        this.variables.splice(index, 1);
      }
    },
    audioFilesUpload(value, id) {
      this.shapes.forEach((shape) => {
        if (shape.id == id) {
          shape.settings.audio = this.tenant_code + "_" + value;
        }
      });
    },
    menuFiles(val, value, id) {
      if (val == "valid") {
        this.shapes.forEach((shape) => {
          if (shape.id == id) {
            shape.settings.files.menu_valid = this.tenant_code + "_" + value;
          }
        });
      }
      if (val == "invalid") {
        this.shapes.forEach((shape) => {
          if (shape.id == id) {
            shape.settings.files.menu_invalid = this.tenant_code + "_" + value;
          }
        });
      }
    },
    dragFlow(ev) {
      //this function is used starts when we drag elements
      // console.log(this.shapes.length);
      // if(this.shapes.length > 4){
      //   this.active = true;
      // }
      this.isNameChanged();
      console.log("nnnnnnnnnnnnnnn");
      ev.dataTransfer.setData("text/html", ev.target.id);
      var crt = ev.target.cloneNode(true);
      crt.style.border = "1px dotted black";
      crt.style.width = "150px";
      crt.style.height = "100px";
      crt.style.borderRadius = "8px";
      document.body.appendChild(crt);
      ev.dataTransfer.setDragImage(crt, 0, 0);
    },
    disableDrag() {
      console.log("5");
      // this function is used to disableDrag
      this.shapes.forEach((shape) => {
        shape.draggable = false;
      });
    },
    enableDrag() {
      console.log("6");
      // this function is used to enableDrag
      this.shapes.forEach((shape) => {
        shape.draggable = true;
      });
    },
    drag(ev, index) {
      // this function is used to get which lines are draging (failure or success)
      ev.stopPropagation();
      ev.dataTransfer.setData("text", "foo");
      this.start = ev.target.parentNode.id;
      let el = ev.target.id;
      if (el == "drag-f") {
        this.lineColor = "#f00";
        this.lineType = "failure";
      } else {
        this.lineColor = "#000";
        this.lineType = "success";
      }
      this.currentFlow = index;
    },
    allowDrop(ev) {
      // this function is used to drop only in grid area or (#div1)
      ev.preventDefault();
    },
    dropArrow(id, ev, index) {
      console.log("7", id, ev);
      // this function is used draw arrow between two elements
      try {
        let isDroppable = true,
          scope = this;
        const flow = this.shapes[this.currentFlow];
        this.shapes.forEach((shape) => {
          shape.showFooter = false;
          shape.draggable = true;
        });
        ev.preventDefault();
        this.end = ev.target.parentNode.id;
        this.line.forEach((line) => {
          let end = line.end.id,

            start = line.start.id;

          if (
            (start == this.end && end == this.start) ||
            (start == this.start && end == this.end)
          ) {
            isDroppable = false;
          }
          if (
            this.lineType == "success" &&
            flow.data != "menu" &&
            flow.next.success != ""
          ) {
            scope.alertmessage =
              "Only menu will create a multiple success event.";
            scope.alert = true;
            isDroppable = false;
          }
          if (this.lineType == "failure" && flow.next.failure != "") {
            scope.alertmessage = "Only allow one failure event each elements.";
            scope.alert = true;
            isDroppable = false;
          }
        });
        const inputString = id;
        const searchString = "trigger";
        console.log(this.start, "333333333333", this.end)
        let index_ = inputString.search(new RegExp(searchString));

        let start_point = "voicemail"
        let end_point = "hangup"
        let start_point_validate = this.start.search(new RegExp(start_point));
        let end_point_validate = this.end.search(new RegExp(end_point));

        if (start_point_validate !== -1 && end_point_validate === -1) {
          scope.alertmessage = "Voice Mail Can Only Link With Hangup";
          scope.alert = true;
          isDroppable = false;
        }
        if (index_ !== -1) {
          scope.alertmessage = "No incoming flow to trigger";
          scope.alert = true;
          isDroppable = false;
        }
        else if (isDroppable) {
          console.log(this.start, this.end)
          let line = new LeaderLine.setLine(
            document.getElementById(this.start),
            document.getElementById(this.end),
            {
              path: "grid",
              color: this.lineColor,
              endPlus: "arrow3",
              size: 1.5,
              // endLabel:  this.end 
            }
          );

          this.line.splice(this.line.length, 1, line);
          let div = document.querySelector("#div1");
          let lines = document.querySelectorAll(".leader-line");
          //           inputs.forEach(function(input) {
          //   input.addEventListener('mouseover', function hover() {
          //     icon.style.background = '#D46855';
          //   });

          //   input.addEventListener('mouseleave', function leave() {
          //     icon.style.background = '#81D455';

          //   });
          // });


          lines.forEach((line, index) => {
            if (this.zoomProperties.current.browser == "chrome") {
              line.style.zoom = div.style.zoom;
            }
            if (this.zoomProperties.current.browser == "firefox") {
              line.style.zoom = div.style.zoom;
              line.style[this.zoomProperties.current.property] =
                this.returnZoom1(this.zoomProperties.current.zoom, 0);
            }
            line.addEventListener("click", () => {
              this.highlightLine(index);
            });
          });

          if (this.lineType == "success") {
            if (flow.next.success == "") {
              flow.next.success = this.shapes[index].id;
            } else {
              flow.next.success =
                flow.next.success + "," + this.shapes[index].id;
            }
          }
          if (this.lineType == "failure") {
            flow.next.failure = this.shapes[index].id;
          }
        }
      } catch (e) {
        console.log("Err =>", e);
      }
    },
    drop(ev) {
      console.log("8", this.shapes);
      // this function is used to drop only in grid area or (#div1)

      // EDITED BY ABDUL SUBHAN TO REMOVE UN WANTED ELEMENT
      // code-review: Please use proper variable name (Ex : tempArray) also fix lint errors
      var data = ev.dataTransfer.getData("text/html");
      var drp = [
        "audio",
        "menu",
        "dial",
        "hangup",
        "sms",
        "validation",
        "voicemail",
        "connection",
        "conference",
      ];
      for (var i = 0; i < drp.length; i++) {
        if (drp[i] == data) {
          const zoom = document.getElementById("div1").style.zoom || 100;
          const zoomInt = parseInt(zoom) / 100;
          ev.preventDefault();
          if (ev.target.id != "drag") {
            data = ev.dataTransfer.getData("text/html");
            if (data) {
              if (data !== "hangup" && !this.elements.includes(data)) {
                this.elements.push(data);
              }
              var flowName = this.flow.name;
              var tempArray = flowName.split(" ");
              flowName = tempArray.join("");
              tempArray = flowName.split("-");
              flowName = tempArray.join("");
              this.shapes.push(
                JSON.parse(
                  JSON.stringify({
                    id: `CTI-${flowName}-${data}${this.shapeCount}`,
                    data: data,
                    name: data,
                    x: ev.offsetX / zoomInt,
                    y: ev.offsetY / zoomInt,
                    w: 150,
                    h: 100,
                    title: `${data.toUpperCase()}`,
                    draggable: true,
                    description: "Description",
                    showFooter: false,
                    showCircle: false,
                    next: {
                      success: "",
                      failure: "",
                    },
                    settings: this.options[data],
                    bgcolor: this.bgcolor[data] || 'white'

                  })
                )
              );
              this.shapeCount += 1;
            }
          }
        }
      }
      // this.showFlowFooter(this.shapeCount)
      console.log("SS", this.shapes);
      // if(this.shape.length>5){
      //   this.active = true;
      // }
    }, //////////////////END EDIT/////////////////////////////////
    activated(index, item) {
      console.log("9", this.menuValues, index, item);
      // this function is used to get or chech the selected element is active or not

      // EDITED BY ABDUL SUBHAN IN MENU ITEM SELECTION
      const scope = this;
      scope.activatedIndex = index;
      scope.shapes[index].showCircle = true;
      scope.selectedFlow = index;
      scope.no_of_params = [];
      scope.no_of_validate = [];
      scope.validateOperation = [];
      scope.validateParam = [];
      scope.validateValue = [];
      scope.shapes.forEach((shape) => {
        if (shape.data === "validation" && shape.id === item.id) {
          if (shape.settings.rules.length > 0) {
            for (let j = 0; j < shape.settings.rules.length; j++) {
              scope.no_of_validate.push(j);
              scope.validateParam[j] = shape.settings.rules[j].parameter;
              scope.validateOperation[j] = shape.settings.rules[j].operation;
              scope.validateValue[j] = shape.settings.rules[j].value;
            }
          } else {
            scope.no_of_params = [1];
            scope.validateValue = [];
            scope.validateParam = [];
            scope.validateOperation = [];
          }
        }
        if (shape.data === "connection" && shape.id === item.id) {
          console.log("SSS", shape.settings.api_param);
          if (shape.settings.api_param.length > 0) {
            for (let j = 0; j < shape.settings.api_param.length; j++) {
              scope.no_of_params.push(j);
            }
            console.log("NOOF", scope.no_of_params);
            scope.paramkeys = shape.settings.api_param;
            scope.paramvalues = shape.settings.api_value;
          } else {
            scope.no_of_params = [1];
            scope.paramkeys = [];
            scope.paramvalues = [];
          }
        }
        if (shape.data === "menu" && shape.id === item.id) {
          console.log("sss", shape.settings.keys.length);

          scope.menuValues = shape.settings.keys;
          scope.menuChoices = shape.settings.choices; console.log("kokoko", scope.menuValues, shape.settings.choices)

          scope.menuItems = [];
          var menu = shape.next.success.split(",");


          for (let i = 0; i < menu.length; i++) {
            if (menu[i] !== "") scope.menuItems.push(menu[i]);
            // shape.settings.choices[i].value = menu[i];
          }
        }
        return shape;
      });
      // scope.menuChoices = [];
    },
    // ########################END#################
    deActivated(id) {
      console.log("10");
      // this function is used to deActivated a element
      this.shapes[id].showFooter = false;
      this.shapes[id].showCircle = false;
    },
    hideFooter(e) {
      console.log("11");
      // this function is used to hideFooter
      if (e.target.id == "div1") {
        this.shapes.forEach((shape) => {
          shape.showFooter = false;
        });
        this.line.forEach((line) => {
          line.outline = false;
        });
      }
    },
    removeFlow(flowIndex, item) {

      // this function is used to removeFlow or file name
      const scope = this;
      scope.generateJSON();
      console.log(scope.flowJSON.data.connections, "rrrrrrrrrrrrrrrrrrrrrrrrrrrr", item)
      let connected_arr = []
      scope.shapes.map(function (shape, shape_id) {


        if (item.id === shape.id) {
          console.log(shape.next, shape_id)

          for (let i = 0; i < scope.flowJSON.data.connections.length; i++) {
            const element = scope.flowJSON.data.connections[i];
            if (element.start === item.id || element.end === item.id) {
              for (let j = 0; j < scope.shapes.length; j++) {
                const element_ = scope.shapes[j];
                // if(element.start===item.id &&element.end===element_.id ){
                //   if(element_.next.failure===item.id ){
                //     element_.next.failure=""
                //   }else if(element_.next.success===item.id){
                //     element_.next.success=""
                //   }

                // }else if(element.end===item.id &&element.start===element_.id ){

                //   if(element_.next.failure===item.id ){
                //     element_.next.failure=""
                //   }else if(element_.next.success===item.id){
                //     element_.next.success=""
                //   }
                // }
                if ((element.start === item.id && element.end === element_.id) || (element.end === item.id && element.start === element_.id)) {

                  let connections = element_.next.failure.split(",");
                  connections.splice(
                    connections.indexOf(item.id),
                    1
                  );
                  element_.next.failure = connections.join(",");
                  let connections_ = element_.next.success.split(",");
                  connections_.splice(
                    connections_.indexOf(item.id),
                    1
                  );
                  element_.next.success = connections_.join(",");
                  console.log(element_.next.success)
                }

              }
              connected_arr.push(element)
            }
          }
          console.log(connected_arr, "itemitemitemitem")
          scope.menuItems.splice(item.id, 1);
          scope.shapes.splice(shape_id, 1);
          let removevalue = []
          for (let i = 0; i < scope.line.length; i++) {
            const element = scope.line[i];
            const endId = element.end.id;
            const startId = element.start.id;
            if (
              startId == shape.id ||
              endId == shape.id
            ) {
              element.remove();
              removevalue.push(element)
            }

          }
          let resultArray = scope.line.filter(item => !removevalue.includes(item));
          scope.line = resultArray
        }

      });

    },
    highlightFlow(id) {
      // this function is used to highlightFlow  in which flow name we are in
      document.getElementById(id).classList.add("hover");
    },
    unHighlightFlow(id) {
      // this function is used to unHighlightFlow
      document.getElementById(id).classList.remove("hover");
    },
    highlightLine(index) {
      // this function is used to highlightLine the dash-dash animation
      this.line.forEach((line) => {
        line.setOptions({
          dash: false,
          size: 1.5,
        });
      });
      this.highlightedFlowIndex = index;
      this.line[index].setOptions({
        dash: {
          animation: true,
        },
        size: 2,
      });
    },
    unHighlightLine(index) {
      // this function is used to unHighlightLine the dash-dash animation
      this.line[index].setOptions({
        dash: false,
        size: 1.5,
      });
    },
    removeLine(index) {
      console.log("13");
      // this function is used to removeLine
      const scope = this;
      scope.shapes.map((shape) => {
        if (shape.id === scope.line[index].start.id) {
          if (scope.line[index].color === "#000") {
            let connections = shape.next.success.split(",");
            connections.splice(
              connections.indexOf(scope.line[index].end.id),
              1
            );
            shape.next.success = connections.join(",");
          } else {
            let connections = shape.next.failure.split(",");
            connections.splice(
              connections.indexOf(scope.line[index].end.id),
              1
            );
            shape.next.failure = connections.join(",");
          }
        }
      });
      scope.line[index].remove();
      scope.$emit("removeLine", index);
      scope.line.splice(index, 1);
      let lines = document.querySelectorAll(".leader-line");
      lines.forEach((line, index) => {
        line.addEventListener("click", () => {
          scope.highlightLine(index);
        });
      });
      // this.highlightedFlowIndex = -1;
    },
    returnZoom(val, step) {
      // this function is used for returnZoom value this function only for chrome

      // EDIT BY ABDUL SUBHAN IN CHROME ZOOM OPTION
      let returnval;
      if (this.zoomProperties.current.browser == "chrome") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${this.zoomProperties.current.suffix
          }`;
      }
      if (this.zoomProperties.current.browser == "firefox") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${this.zoomProperties.current.suffix
          }`;
      }

      return returnval;
    },
    //////////////////END EDIT/////////////////////////////////

    returnZoom1(val, step) {
      // this function is used for returnZoom value this function only for firefox

      // EDIT BY ABDUL SUBHAN IN firefox ZOOM OPTION
      let returnval;
      if (this.zoomProperties.current.browser == "chrome") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${this.zoomProperties.current.suffix
          }`;
      }
      if (this.zoomProperties.current.browser == "firefox") {
        returnval = `${this.zoomProperties.current.prefix}1${this.zoomProperties.current.suffix}`;
      }
      return returnval;
    }, //////////////////END EDIT/////////////////////////////////

    zoomIn() {
      // this function is used zoom in
      let div = document.querySelector("#div1");
      let zoom =
        document.querySelector("#div1").style[
        this.zoomProperties.current.property
        ];
      let lines = document.querySelectorAll(".leader-line");
      if (!zoom || zoom === "") {
        div.style["transform-origin"] = "left top";
        div.style[this.zoomProperties.current.property] = this.returnZoom(
          this.zoomProperties.current.zoom,
          0
        );
        if (lines) {
          lines.forEach((line) => {
            line.style[this.zoomProperties.current.property] = this.returnZoom(
              this.zoomProperties.current.zoom,
              0
            );
          });
        }
      }
      if (this.zoomProperties.current.zoom <= this.zoomProperties.current.max) {
        div.style["transform-origin"] = "left top";
        let zoomVal = this.returnZoom(
          this.zoomProperties.current.zoom,
          this.zoomProperties.current.step
        );
        let newZoom =
          this.zoomProperties.current.zoom + this.zoomProperties.current.step;
        this.handleZoom(div, lines, zoomVal, newZoom);
      }
    },
    zoomOut() {
      // this function is used zoom out
      let div = document.querySelector("#div1");
      let zoom =
        document.querySelector("#div1").style[
        this.zoomProperties.current.property
        ];
      let lines = document.querySelectorAll(".leader-line");
      if (!zoom || zoom === "") {
        div.style["transform-origin"] = "left top";
        div.style[this.zoomProperties.current.property] = this.returnZoom(
          this.zoomProperties.current.zoom,
          0
        );
        if (lines) {
          lines.forEach((line) => {
            line.style[this.zoomProperties.current.property] = this.returnZoom(
              this.zoomProperties.current.zoom,
              0
            );
          });
        }
      }
      if (this.zoomProperties.current.zoom >= this.zoomProperties.current.min) {
        div.style["transform-origin"] = "left top";
        var zoomVal = this.returnZoom(
          this.zoomProperties.current.zoom,
          this.zoomProperties.current.step * -1
        );
        let newZoom =
          this.zoomProperties.current.zoom - this.zoomProperties.current.step;
        this.handleZoom(div, lines, zoomVal, newZoom);
      }
    },
    handleZoom(div, lines, zoomVal, newZoom) {
      // this function is used handleZoom event this is main function in zoom
      div.style[this.zoomProperties.current.property] = zoomVal;
      if (lines) {
        lines.forEach((line) => {
          if (this.zoomProperties.current.browser == "chrome") {
            line.style[this.zoomProperties.current.property] = zoomVal;
          }
          if (this.zoomProperties.current.browser == "firefox") {
            line.style[this.zoomProperties.current.property] = this.returnZoom1(
              this.zoomProperties.current.zoom,
              0
            );
          }
        });
      }
      this.positionLine()
      // this.line.forEach((line) => {
      //  line.size=line.size+0.5
      //  console.log("ytttttttttttttttt",line.size,333333333333333,line)

      //   line.position();
      // });
      this.zoomProperties.current.zoom = newZoom;
      this.snackbar = true;
    },
    uploadJSON() {
      // this function is used to upload uploadJSON data
      var scope = this;

      scope.generateJSON();
      let widget = scope.flowJSON.data.values
      if (validation_function(Object.values(widget)).length > 0) {
        scope.showSnackBar("Validation Error In " + validation_function(Object.values(widget)).toString());
      } else {
        let main_arr = []
        let sub_arr = []
        for (let i = 0; i < Object.keys(widget).length; i++) {
          if (Object.keys(widget)[i].data !== 'trigger') {
            main_arr.push(Object.keys(widget)[i])
          }
        }
        for (let j = 0; j < scope.flowJSON.data.connections.length; j++) {
          const element = scope.flowJSON.data.connections[j];
          sub_arr.push(element.end)
        }
        let connection_validate = {}
        for (let k = 0; k < main_arr.length; k++) {
          const element = main_arr[k];
          let filter = sub_arr.filter((e) => {
            if (element === e) {
              return e
            }
          })
          if (filter.length === 0) {
            connection_validate[element] = false
          }
        }
        if (Object.keys(connection_validate).length > 0) {
          scope.showSnackBar("Flow Is Missing");
        }
        else {
          console.log("eeeeeeeeeeeeeeeeeeeeeeeee")
          scope.$store
            .dispatch("postCallFlow", scope.flowJSON)
            .then((response) => {
              scope.isProcessing = false;
              if (response.data.statusCode === 200) {
                this.flow.name = "Untitled1";
                scope.showSnackBar("Uploaded Successfully");
                scope.$router.push({ name: "CallFlow" });
              } else {
                scope.showSnackBar("Create error-" + response.message);
              }
            })
            .catch(function () {
              scope.showSnackBar("Upload Failed..!");
            });
        }
      }

    },
    generateJSON() {
      console.log("14");
      // this function is used to generateJSON
      let values = {};
      var FlowName = this.flow.name;
      var NameSplit = FlowName.split(" ");
      FlowName = NameSplit.join("");
      NameSplit = FlowName.split("-");
      FlowName = NameSplit.join("");
      this.shapes.map(function (shape) {
        var tempArray = shape.id.split("-");
        var id =
          tempArray[0] + "-" + FlowName + "-" + tempArray[tempArray.length - 1];
        shape.id = id;
        return shape;
      });
      const flows = this.shapes.slice(1);
      for (var i = 0; i < flows.length; i++) {
        var id = flows[i].id;
        if (flows, flows[i].settings.choices !== undefined) {
          flows[i].settings.choices = flows[i].next.success.split(",")
        }
        values[id] = flows[i];
      }
      const connections = this.line.map((line) => {
        return {
          end: line.end.id,
          start: line.start.id,
        };
      });
      const variable = this.variables;
      const json = {
        name: this.flow.name,
        data: {
          start: {
            ...this.shapes[0],
            flowType: "start",
          },
          values,
          connections,
          variable,
        },
      };
      console.log("LLL", json);
      this.flowJSON = json;
      this.$store.dispatch("updateJSON", json);
      console.log("JSON", this.shapes);
    },
    // dragEnd(x, y) {
    // this.shapes[this.activatedIndex].x = x;
    // this.shapes[this.activatedIndex].y = y;
    // },
  },
  updated() {
    const scope = this;
    if (scope.lines.length > 0) {
      scope.lines.forEach((line) => {
        const id = line.end.id.split("-")[1];
        var FlowName = scope.flow.name;
        var NameSplit = FlowName.split(" ");
        FlowName = NameSplit.join("");
        NameSplit = FlowName.split("-");
        FlowName = NameSplit.join("");
        if (id != FlowName) {
          line.hide();
        } else {
          line.show();
        }
      });
    }
  },
  watch: {
    showJSON(val) {
      this.showJSONComponent = val;
      if (val) {
        this.generateJSON();
      }
    },
    //     visibleId(){

    // this.watchers = !this.watchers;
    // // this.dropArrow();
    // console.log("9800",this.watchers);
    //     }
  },
  computed: {
    ...mapGetters(["getJSON"]),
    zoomalert() {
      return (
        this.zoomProperties.current.zoom * this.zoomProperties.current.unit +
        "%"
      );
    },
    dialVariables() {
      let temp = ["DID Number", 'Dial Status', "Caller", "Agent"];
      return this.variables.filter((e) => {
        return !temp.includes(e);
      });
    },
  },
  beforeDestroy() {
    this.line.forEach((line) => {
      line.remove();
    });
  },
};
</script>
<style>
body {
  overflow: hidden;
}


body .leader-line:hover {
  background-color: aqua;
  /* pointer-events: auto !important; */
}

.header {
  border-width: 1px 0 1px;
  border-style: solid;
}

.hover {
  border: 1.5px solid red;
}

.controls {
  position: fixed;
  display: flex;
  bottom: 10px;
  right: 0px;
}

.controls i {
  display: block;
  color: #fff !important;
  background: #424242;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  padding: 10px 0;
  margin: 10px 0;
}

/* .zoom_button_class {} */

.zoom-in-bts,
.zoom-out-bts {
  top: 627px;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px;
}

.zoom-in-bts {
  right: 30px;
}

.zoom-out-bts {
  right: 80px;
}

.flow {
  box-shadow: 1px 1px 13px #999;
  position: absolute;
  border-radius: 5px;
}

.draggable.resizable.flow.active,
.check.highlight {
  box-shadow: 1px 1px 14px #666;
}

/* .v-tooltip__content {
  background: #fcbe03;
  color: red;
} */
.check.highlight>.custom-handle {
  display: block !important;
}

.v-tooltip__content--fixed {
  top: 260px !important;
}

.mainViewFlex {
  display: flex;
  flex-direction: column;


}

.list_item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}

.nav_component {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100px;
  padding: 3px
}

.nav_component:hover {
  background-color: #e4dede;
  border-radius: 5px;
}

.icon-txt {
  width: 100px;
  text-align: center;
}

.nav_items {
  text-align: center;

}

.navbarcomponent {
  padding: 5px;
  z-index: 2;
  position: relative;
  background-color: white;
  border: 1px solid #cacaca;


}

.menu {
  color: #4a4a4a !important;
}

.audio {
  color: #ffa500 !important;
}

.sms {
  color: #1da1f2 !important;
}

.voice {

  color: #8a2be2 !important;
}

.validation {
  color: #28a745 !important;
}

.connection {
  color: #20c997 !important;
}

.conference {
  color: #20c997 !important;
}

.dial {
  color: #32cd32 !important
}

.hangup {
  color: #ff4b4b !important
}

.upl_btn {
  display: flex;
  justify-content: right;
  padding: 0px 225px 0px 10px;

  /* position: relative; */
  background-color: #ffffff;
  border: 1px solid #cacaca;
  margin-bottom: 30px;

  position: fixed !important;
  top: 562px !important;
  width: 100% !important;
  display: flex;
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;

  z-index: 1;
  position: relative;

}

.bts_clss {
  margin: 10px;
  width: 90px;
  height: 35px;
  max-height: 60px;
  border-radius: 5px
}

.input_ {
  margin: 10px !important;
}

.v-tabs-item.v-tabs-item--active {
  background-color: #ff0000 !important;
  /* Change the background color for the active tab */
  color: #ffffff !important;
  /* Change the text color for the active tab */
}

.tabflex {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  background-color: #2194f3 !important;
  color: #ffffff;
  text-align: center;
}

.tabitem {
  background-color: #ffffff !important;
  color: #000000;
}

.custom-input {
  width: 100% !important;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  /* border-radius: 5px; */
  font-size: 16px;
  margin-bottom: 10px;
  outline: none;
  border-top: none;
  border-left: none;
  border-right: none;
  transition: border-color 0.2s;

}

.custom-input:focus {
  border-color: #007bff;
}

.validation_row {
  width: 100%;
  border: 1px solid #cacaca;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 5px;
  /* display: flex;
  flex-direction: row; */
}

.tabitempadding {
  cursor: pointer;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
}



.container-fluid {
  height: 100%;
}

.body html {
  height: 100%;

}

/* .canvas .scrolling-canvas #div1 .content .content__header div {
    font-family: sans-serif !important;
    padding: 2px 3px !important;
    margin-right: 6px;
} */
.leader-line {
  color: #28a745 !important
}

.zoom {
  height: 8000vh !important;
}

.canvas .scrolling-canvas #div1 .content .content__header div {
  font-family: sans-serif !important;
  padding: 2px 5px !important;

}
/* @media screen and (max-width: 1435px) and (max-height: 620px) {
  .upl_btn {
    top: 562px !important;
    
  }
} */
@media screen and (min-width: 1280px) and (min-height:550px){
  .upl_btn {
    top: 500px !important;
    
  }
}
@media screen and (min-width: 1435px){
  .upl_btn {
    top: 692px !important;
    
  }
}
@media screen and (min-width: 1480px)  {
  .upl_btn {
    top: 689px !important;
    
  }
}
@media screen and (min-width: 1643px)  {
  .upl_btn {
    top: 777px !important;
    
  }
}
@media screen and (min-width: 1700px)  {
  .upl_btn {
    top: 777px !important;
    
  }
}
@media screen and (min-width: 1849px)  {
  .upl_btn {
    top: 880px !important;
    
  }
}
@media screen and (min-width: 1913px)  {
  .upl_btn {
    top: 770px !important;
    
  }
}

@media screen and (min-width: 1920px) {
  .upl_btn {
    top: 942px !important; 
  }
}
@media screen and (min-width: 2218px) {
  .upl_btn {
    top: 1066px !important; 
  }
}
@media screen and (min-width: 2958px) {
  .upl_btn {
    top: 1437px !important; 
  }
}










</style>